import withSessionStorage from '%evp_ticket_frontend/js/redesign/services/withSessionStorage';
import isPageLoadFailure from './isPageLoadFailure';
import { prefixKey } from './storageService';

export const RETRY_DELAYS_MS = [1000, 2000, 4000];
export const RELOAD_GUARD_STORAGE_KEY = prefixKey('page-load-failure-reloads');
export const RELOAD_GUARD_DURATION_MS = 10 * 60 * 1000;

function wait(delayMs) {
    return new Promise((resolve) => {
        setTimeout(resolve, delayMs);
    });
}

function failedFileUrlOf(error) {
    return typeof error.request === 'string' ? error.request : null;
}

function parseReloads(storedReloads) {
    try {
        const reloads = JSON.parse(storedReloads);

        return Array.isArray(reloads) ? reloads : [];
    } catch (error) {
        return [];
    }
}

function isRecentReload(reload, now) {
    return reload !== null
        && typeof reload === 'object'
        && now - Number(reload.reloadedAt) < RELOAD_GUARD_DURATION_MS;
}

function claimReload(failedFileUrl) {
    return withSessionStorage((storage) => {
        const now = Date.now();
        const recentReloads = parseReloads(storage.getItem(RELOAD_GUARD_STORAGE_KEY))
            .filter(reload => isRecentReload(reload, now));
        if (recentReloads.some(reload => reload.fileUrl === failedFileUrl)) {
            return false;
        }
        storage.setItem(
            RELOAD_GUARD_STORAGE_KEY,
            JSON.stringify([...recentReloads, { fileUrl: failedFileUrl, reloadedAt: now }]),
        );

        return true;
    }) === true;
}

function reloadOnce(error) {
    if (window.navigator.onLine === false || !claimReload(failedFileUrlOf(error))) {
        return false;
    }
    window.location.reload();

    return true;
}

async function importWithRetries(importer, retryDelaysMs) {
    try {
        return await importer();
    } catch (error) {
        if (!isPageLoadFailure(error) || retryDelaysMs.length === 0) {
            throw error;
        }
        await wait(retryDelaysMs[0]);

        return importWithRetries(importer, retryDelaysMs.slice(1));
    }
}

async function retryPageImport(importer) {
    const requestedPathname = window.location.pathname;

    try {
        return await importWithRetries(importer, RETRY_DELAYS_MS);
    } catch (error) {
        if (isPageLoadFailure(error) && window.location.pathname === requestedPathname && reloadOnce(error)) {
            return new Promise(() => {});
        }

        throw error;
    }
}

export default retryPageImport;
